import { motion } from "framer-motion";
import {
  IconCheck,
  IconClock,
  IconLeaf,
  IconPin,
  IconShield,
  IconSparkle,
} from "../Icon";
import { Reveal } from "../motion/Reveal";
import { Stagger, StaggerItem } from "../motion/Stagger";

const items = [
  {
    icon: IconPin,
    title: "Entreprise locale de Vichy",
    text: "Basée à Vichy, nous connaissons le tissu économique de l'Allier et intervenons rapidement chez nos clients.",
  },
  {
    icon: IconShield,
    title: "Interlocuteur unique & assuré",
    text: "Le même interlocuteur du devis au contrôle qualité, protocoles maîtrisés et responsabilité civile pro.",
  },
  {
    icon: IconClock,
    title: "Interventions flexibles",
    text: "Tôt le matin, en soirée ou le week-end pour ne pas perturber votre activité.",
  },
  {
    icon: IconLeaf,
    title: "Produits éco-labellisés",
    text: "Dosage maîtrisé, microfibres, produits respectueux des surfaces et de la santé.",
  },
  {
    icon: IconSparkle,
    title: "Résultat garanti",
    text: "Si un point n'est pas conforme, nous revenons sous 24 h. Carnet de passage fourni.",
  },
  {
    icon: IconCheck,
    title: "Devis gratuit sous 48 h",
    text: "Un échange clair, un cahier des charges précis et un tarif ferme - sans engagement ni frais cachés.",
  },
];

export function WhyUs() {
  return (
    <section className="section bg-surface-soft relative overflow-hidden">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 left-1/3 h-80 w-80 rounded-full bg-brand-300/20 blur-3xl"
      />
      <div className="container-page relative">
        <Reveal as="header" className="max-w-2xl">
          <span className="eyebrow">Pourquoi nous choisir</span>
          <h2 className="mt-4">Un partenaire fiable, discret et exigeant</h2>
          <p className="mt-4 text-ink-muted text-lg">
            Un seul interlocuteur, un suivi personnalisé, un niveau d'exigence constant. C'est la
            promesse que nous tenons chaque jour à Vichy.
          </p>
        </Reveal>

        <Stagger className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => (
            <StaggerItem key={it.title}>
              <motion.div
                whileHover={{ y: -4 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="card card-hover h-full"
              >
                <div className="flex items-start gap-4">
                  <div className="grid h-11 w-11 place-items-center rounded-xl bg-accent-500/10 text-accent-700 flex-none ring-1 ring-accent-500/20">
                    <it.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-lg">{it.title}</h3>
                    <p className="mt-1.5 text-sm text-ink-muted leading-relaxed">{it.text}</p>
                  </div>
                </div>
              </motion.div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
